import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { PageHeader } from '@/components/common/PageHeader';
import { useNotify } from '@/hooks/useNotify';

import { ProtocoloForm } from '../components/ProtocoloForm';
import { useCreateProtocolo } from '../hooks/useProtocolos';
import type { ProtocoloFormValues } from '../schemas';

export function NuevoProtocoloPage(): JSX.Element {
  const navigate = useNavigate();
  const notify = useNotify();
  const mutation = useCreateProtocolo();

  async function handleSubmit(values: ProtocoloFormValues): Promise<void> {
    const created = await mutation.mutateAsync({
      uid_profesional: values.uid_profesional,
      uid_establecimiento: values.uid_establecimiento,
      fecha_recepcion: values.fecha_recepcion?.toISOString() ?? new Date().toISOString(),
      fecha_protocolo: values.fecha_protocolo?.toISOString() ?? new Date().toISOString(),
    });
    notify.success(`Protocolo N° ${created.numero_protocolo} creado.`);
    navigate(`/protocolos/${created.uid_protocolo}`);
  }

  return (
    <>
      <PageHeader
        title="Nuevo protocolo"
        action={
          <Button
            startIcon={<ArrowBackIcon />}
            onClick={() => navigate('/protocolos')}
          >
            Volver
          </Button>
        }
      />
      <ProtocoloForm
        onSubmit={(v) => void handleSubmit(v)}
        onCancel={() => navigate('/protocolos')}
        submitting={mutation.isPending}
        error={mutation.error}
      />
    </>
  );
}
